import { Bean } from '../types/bean';

type Visitor<DATA, ACCEPT> = (data: DATA) => ACCEPT;

export type VisitorsMap<VISITORS_MAP extends Bean, ACCEPT> = {
   [KEY in keyof VISITORS_MAP]-?: Visitor<VISITORS_MAP[KEY], ACCEPT>;
};

type PartialVisitor<DATA, ACCEPT> = (data: DATA) => ACCEPT | undefined;

type PartialVisitorsMap<VISITORS_MAP extends Bean, ACCEPT> = {
   [KEY in keyof VISITORS_MAP]?: PartialVisitor<VISITORS_MAP[KEY], ACCEPT>;
};

type InferAccept<T, VISITORS_MAP extends Bean, ACCEPT> = [keyof VISITORS_MAP] extends [keyof T]
   ? ACCEPT
   : ACCEPT | undefined;

export const createVisitor = <DATA, VISITORS_MAP extends Bean>(
   creator: (data: DATA, visitors: PartialVisitorsMap<VISITORS_MAP, any>) => any
) => {
   return <ACCEPT>(
      data: DATA,
      visitors: PartialVisitorsMap<VISITORS_MAP, ACCEPT>
   ): InferAccept<typeof visitors, VISITORS_MAP, ACCEPT> => {
      return creator(data, visitors);
   };
};
